// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-content [class*=\"MuiGrid-container\"],.main-content [class*=\"MuiGrid-container\"]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.main-content .description-section-content{text-align:center}.main-content .subtitle{color:#a9a9a9;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;font-family:\"GothamSSm-Light\",Arial,sans-serif;font-size:24px;margin-top:70px}\n", ""]);
// Exports
module.exports = exports;
